import { v4 } from 'uuid';
import { ChromeAppMessage, ChromeAppResponse } from 'Environment/ChromeApp/types';

export namespace ChromeAndHtml5 {
	export const SUCCESS = 'successful';

	export type AppConfigTokenRequiredResponse = ChromeAppResponse & {
		isTokenRequired: boolean;
	};

	// This the structure we get when we receive messages in window event listener.
	// note the data property is one which contains actual info sent by the client apps.
	export type WindowEventMessageType = {
		data?: ChromeAppResponse;
	};

	//TODO: This has to be consolidated at one place.
	export type TokenData = {
		accesstoken: string;
		metadata: string;
		storeurl: string;
	};

	export function msgAppConfigTokenRequiredReq(): ChromeAppMessage {
		return {
			header: {
				type: 'appConfigTokenRequiredReq',
			},
			payload: {
				correlationId: v4(),
			},
		};
	}

	export function msgAppConfigFetchWithTokenReq(tokenData: TokenData): ChromeAppMessage {
		return {
			header: {
				type: 'appConfigFetchWithTokenReq',
			},
			payload: {
				...tokenData,
				correlationId: v4(),
			},
		};
	}
}
